import api from '@/api'

export const fetchDocuments = () => {
  return api.get('documents')
}

export const getDocument = idDoc => {
  return api.get(`documents/${idDoc}`)
}

export default { getDocument, fetchDocuments }



// WEBPACK FOOTER //
// ./src/services/documentService.js